module.exports = __webpack_public_path__ + "mybuild/static/img/footerlogo02.e5aa3bae.png";